import { Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

import { useDateUtils } from "../../../utils/formatTime";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";

export default function TaskCompletedComp({
  selectedFilter,
  SelectedData,

  monthName,
  selectedYear,
  fromDate,
  toDate,
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  const columns = [
    {
      field: "type_of_task",
      headerName: "Type Of Task",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params?.row?.type_of_task?.name_of_task_type || "",
      renderCell: (params) => (
        <div>{params?.row.type_of_task?.name_of_task_type}</div>
      ),
    },
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row.enquiry_id.id}`,
              "_blank"
            )
          }
        >
          {" "}
          {`${
            params?.row?.enquiry_id?.first_name
              ? params?.row?.enquiry_id?.first_name
              : ""
          } ${
            params?.row?.enquiry_id?.last_name
              ? params?.row?.enquiry_id?.last_name
              : ""
          }`}{" "}
        </div>
      ),
    },
    {
      field: "task_owner",
      headerName: "Task Owner",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params?.row?.task_owner?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.task_owner?.first_name}{" "}
          {params?.row.task_owner?.last_name}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      minWidth: 100,
      headerAlign: "center",
      align: "center",

      valueGetter: (params) => params?.row?.status || "",
      renderCell: (params) => (
        <div>
          {params?.row?.status === 1 ? (
            <Chip label="open" size="small" color="error" variant="contained" />
          ) : (
            <Chip
              label="closed"
              size="small"
              color="secondary"
              variant="contained"
            />
          )}{" "}
        </div>
      ),
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params?.row?.created_by?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.created_by?.first_name}{" "}
          {params?.row.created_by?.last_name}
        </div>
      ),
    },
    {
      field: "created_date",
      headerName: "Created At",
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      headerClassName: "header-cell",
    },
    {
      field: "closed_date",
      headerName: "Closed Date",
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      headerClassName: "header-cell",
    },
  ];
  return (
    <>
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {selectedFilter === "default" && (
              <Typography variant="h4" textAlign="center">
                {monthName} {selectedYear}
              </Typography>
            )}

            {selectedFilter === "today" && (
              <Typography variant="h4" textAlign="center">
                Today ({currentDate})
              </Typography>
            )}
            {selectedFilter === "currentweek" && (
              <Typography variant="h4" textAlign="center">
                This Week ({weekRange})
              </Typography>
            )}

            {selectedFilter === "currentmonth" && (
              <Typography variant="h4" textAlign="center">
                {currentMonthName} {currentYear}
              </Typography>
            )}

            {selectedFilter === "custom" && (
              <Typography variant="h4" textAlign="center">
                {fromDate} - {toDate}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              rows={SelectedData}
              columns={columns}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              autoHeight
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </Grid>
        </Grid>
      </>
    </>
  );
}
